import { memo } from "react";

import AppPropTypes from "../model/propTypes";

import "./LineIcon.scss";

const propTypes = {
  line: AppPropTypes.line.isRequired,
};

function LineIcon({ line }) {
  return (
    <div
      className="line-icon"
      style={{
        backgroundColor: line.color,
        borderColor: line.color === "#ffffff" ? "black" : line.color,
        color: line.text_color,
      }}
    >
      <span>{line.name}</span>
    </div>
  );
}

LineIcon.propTypes = propTypes;

export default memo(LineIcon);
